/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import { useServiceContext } from '../../../root'
import type { Tag } from '../../../services/api/api.tags'
import ActionsMenu from '../../../components/shared/ActionsMenu'
import ModalRemove from './Actions/ModalRemove'

interface TableMenuProps {
  item: Tag
  onEditTag: (tag: Tag) => void
  onDeleteSuccess?: () => void
}

const TableMenu: React.FC<TableMenuProps> = ({ item, onEditTag, onDeleteSuccess }) => {
  const context = useServiceContext()
  const [showRemoveModal, setShowRemoveModal] = useState(false)

  const handleEdit = () => {
    onEditTag(item)
  }

  const handleRemove = () => {
    setShowRemoveModal(true)
  }

  const settings = {
    menuId: `action-menu-tag-${item.id}`,
    items: [
      {
        value: 'ACTION_EDIT',
        action: handleEdit
      },
      {
        value: 'ACTION_REMOVE',
        action: handleRemove
      }
    ]
  }

  return (
    <>
      <ActionsMenu {...settings} />
      {showRemoveModal && (
        <ModalRemove
          tag={item}
          onClose={() => setShowRemoveModal(false)}
          onSuccess={() => {
            setShowRemoveModal(false)
            if (onDeleteSuccess) {
              onDeleteSuccess()
            }
          }}
        />
      )}
    </>
  )
}

export default TableMenu
